<div class="base-modal-container">
  <slotcom-navigation-button
    type="close"
    (click)="closeModal()"></slotcom-navigation-button>
  <slotcom-navigation-button
    type="info"
    (click)="openInfo()"></slotcom-navigation-button>
  <div class="base-modal-title">
    {{ 'home.trophies-recurring-ranking.title' | translate | uppercase }}
  </div>
  <div
    class="base-modal-content"
    [ngClass]="{ 'blur-disabled': both_Disabled }">
    <div class="base-modal-ranking">
      <slotcom-recurring-ranking (rankingDisabled)="rankingDisabled($event)"></slotcom-recurring-ranking>
    </div>
    <div class="base-modal-trophies">
      <div class="base-modal-trophies-earned">
        <slotcom-recurring-hall
          (hallDisabled)="trophiesDisabled($event)"
          [user]="user"></slotcom-recurring-hall>
      </div>
      <div class="base-modal-sachet">
        <slotcom-shop-recurring-bag></slotcom-shop-recurring-bag>
      </div>
    </div>
  </div>
  @if (both_Disabled) {
    <div class="base-modal-content">
      <div class="disabled disabled-trophies_img"></div>
      <div
        class="disabled disabled-hint_text"
        [innerHTML]="'home.recurring-ranking.help-no-available' | translate"></div>
    </div>
  }
</div>
